import { useState, useCallback } from "react";

import FormTextInput from "../../../../../../Components/FormInput";

import "./ForgotPasswordForm.css";

const FORGOT_PASSWORD_FORM_LABELS = {
  EMAIL: "Email",
};

const ForgotPasswordForm = (props) => {
  const { onClickSubmitAccountRecovery } = props;
  const [email, setEmail] = useState("");
  const handleEmailChange = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );
  return (
    <div className="forgot-password-form-container">
      <div>Forgot Password?</div>
      <div>
        No worries we'll get you back into your account ASAP. What was the email
        asssociated with your account?
      </div>
      <FormTextInput
        inputLabel={FORGOT_PASSWORD_FORM_LABELS.EMAIL}
        onChange={handleEmailChange}
        value={email}
      />
      <div className='login-button' onClick={onClickSubmitAccountRecovery}>
        Submit
      </div>
      {/* <button onClick={onClickSubmitAccountRecovery}>Submit</button> */}
    </div>
  );
};

export default ForgotPasswordForm;
